/**
 * @generated SignedSource<<df35e3d1eebd6c7104af0a679b2c5fe2>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type sectionSearchResultListSectionSearchEdge$data = ReadonlyArray<{
  readonly node: {
    readonly content: {
      readonly entityId: string;
      readonly fullSectionPath: ReadonlyArray<{
        readonly " $fragmentSpreads": FragmentRefs<"helpersCheckIfNewsSectionInFirstIndexSection">;
      } | null | undefined> | null | undefined;
      readonly " $fragmentSpreads": FragmentRefs<"itemSectionSearchResultListItemSection">;
    } | null | undefined;
  };
  readonly " $fragmentType": "sectionSearchResultListSectionSearchEdge";
}>;
export type sectionSearchResultListSectionSearchEdge$key = ReadonlyArray<{
  readonly " $data"?: sectionSearchResultListSectionSearchEdge$data;
  readonly " $fragmentSpreads": FragmentRefs<"sectionSearchResultListSectionSearchEdge">;
}>;

const node: ReaderFragment = (function(){
var v0 = [
  {
    "alias": null,
    "args": null,
    "kind": "ScalarField",
    "name": "name",
    "storageKey": null
  }
];
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": {
    "plural": true
  },
  "name": "sectionSearchResultListSectionSearchEdge",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SectionSearchResultItem",
      "kind": "LinkedField",
      "name": "node",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "Section",
          "kind": "LinkedField",
          "name": "content",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "entityId",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "concreteType": "Section",
              "kind": "LinkedField",
              "name": "fullSectionPath",
              "plural": true,
              "selections": [
                {
                  "kind": "InlineDataFragmentSpread",
                  "name": "helpersCheckIfNewsSectionInFirstIndexSection",
                  "selections": [
                    {
                      "kind": "InlineFragment",
                      "selections": [
                        {
                          "kind": "InlineFragment",
                          "selections": (v0/*: any*/),
                          "type": "Section",
                          "abstractKey": null
                        },
                        {
                          "kind": "InlineFragment",
                          "selections": (v0/*: any*/),
                          "type": "VideoSection",
                          "abstractKey": null
                        }
                      ],
                      "type": "SectionUnion",
                      "abstractKey": "__isSectionUnion"
                    }
                  ],
                  "args": null,
                  "argumentDefinitions": []
                }
              ],
              "storageKey": null
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "itemSectionSearchResultListItemSection"
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "SectionSearchEdge",
  "abstractKey": null
};
})();

(node as any).hash = "7263b28eb5516cffe0e5312748bf9f8a";

export default node;
